import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_ROUTES } from '../config/api';
import '../styles/Analyse.css';

const Analyse = () => {
  const [formData, setFormData] = useState({
    poidsActuel: '',
    poidsInitial: '',
    hydratation: '',
    objectifPoids: ''
  });
  const [analyse, setAnalyse] = useState(null);
  const [historique, setHistorique] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchHistorique();
  }, []);

  const fetchHistorique = async () => {
    try {
      const { data } = await axios.get(API_ROUTES.ANALYSE_HISTORIQUE);
      setHistorique(data.analyses || []);
    } catch (err) {
      setError('Erreur lors de la récupération de l\'historique');
      console.error('Erreur historique:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Vérifier le token
      const token = localStorage.getItem('token');
      console.log('Token présent:', !!token);
      
      const { data } = await axios.post(API_ROUTES.ANALYSE, formData);
      console.log('Réponse API:', data);
      setAnalyse(data.data);
      fetchHistorique();
      setError('');
    } catch (err) {
      console.error('Erreur analyse:', err.response?.data || err.message);
      setError(err.response?.data?.message || 'Une erreur est survenue');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="analyse-container">
      <h1 className="analyse-title">Analyse de votre progression</h1>
      
      <div className="analyse-grid">
        <div className="analyse-card">
          <h2>Nouvelle analyse</h2>
          <form onSubmit={handleSubmit} className="analyse-form">
            <div className="form-group">
              <label>Poids actuel (kg)</label>
              <input
                type="number"
                name="poidsActuel"
                value={formData.poidsActuel}
                onChange={handleChange}
                step="0.1"
                required
              />
            </div>

            <div className="form-group">
              <label>Poids initial (kg)</label>
              <input
                type="number"
                name="poidsInitial"
                value={formData.poidsInitial}
                onChange={handleChange}
                step="0.1"
                required
              />
            </div>

            <div className="form-group">
              <label>Hydratation (L/jour)</label>
              <input
                type="number"
                name="hydratation"
                value={formData.hydratation}
                onChange={handleChange}
                step="0.1"
                required
              />
            </div>

            <div className="form-group">
              <label>Objectif de poids (kg)</label>
              <input
                type="number"
                name="objectifPoids"
                value={formData.objectifPoids}
                onChange={handleChange}
                step="0.1"
                required
              />
            </div>

            <button type="submit" className="submit-button">
              Analyser
            </button>
          </form>
        </div>

        {analyse && analyse.details && (
          <div className={`analyse-card result ${analyse.alerte ? 'alert' : 'success'}`}>
            <h2>Résultat de l'analyse</h2>
            <div className="message">{analyse.message}</div>
            <div className="details">
              <div className="detail-item">
                <span>Perte de poids :</span>
                <span>{analyse.details.pertePoids} kg</span>
              </div>
              <div className="detail-item">
                <span>Distance de l'objectif :</span>
                <span>{analyse.details.distanceObjectif} kg</span>
              </div>
              <div className="detail-item">
                <span>Hydratation :</span>
                <span className={analyse.details.hydratationSuffisante ? 'success' : 'warning'}>
                  {analyse.details.hydratationSuffisante ? 'Suffisante' : 'Insuffisante'}
                </span>
              </div>
              <div className="detail-item">
                <span>Vitesse de perte :</span>
                <span className={analyse.details.vitessePertePoidsSaine ? 'success' : 'warning'}>
                  {analyse.details.vitessePertePoidsSaine ? 'Saine' : 'Trop rapide'}
                </span>
              </div>
            </div>
          </div>
        )}

        <div className="analyse-card">
          <h2>Historique des analyses</h2>
          <div className="historique-list">
            {historique.map((item, index) => (
              <div key={index} className={`historique-item ${item.alerte ? 'alert' : 'success'}`}>
                <div className="historique-date">
                  {new Date(item.date).toLocaleDateString('fr-FR')}
                </div>
                <div className="historique-poids">
                  <span>Poids : {item.poidsActuel} kg</span>
                  <span>Hydratation : {item.hydratation}L</span>
                </div>
                <div className="historique-message">{item.message}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default Analyse; 